/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Ft_4_TitleInputs */

const en_vc_ft_4_title = /** @type {(inputs: Vc_Ft_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perspective Grid`)
};

const zh_vc_ft_4_title = /** @type {(inputs: Vc_Ft_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`透视网格`)
};

/**
* | output |
* | --- |
* | "Perspective Grid" |
*
* @param {Vc_Ft_4_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_ft_4_title = /** @type {((inputs?: Vc_Ft_4_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Ft_4_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_ft_4_title(inputs)
	return zh_vc_ft_4_title(inputs)
});
export { vc_ft_4_title as "vc.ft.4.title" }